var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarningToastYellow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3695 3.93724L2.23299 18.3191C1.5509 19.5248 2.44813 21 3.86349 21H20.1365C21.5519 21 22.4491 19.5248 21.767 18.3191L13.6305 3.93723C12.9235 2.68759 11.0765 2.68759 10.3695 3.93724ZM12 8.63816C12.5138 8.63816 12.9304 9.04313 12.9304 9.54269V14.3668C12.9304 14.8664 12.5138 15.2713 12 15.2713C11.4861 15.2713 11.0696 14.8664 11.0696 14.3668V9.54269C11.0696 9.04313 11.4861 8.63816 12 8.63816ZM12.9304 17.0804C12.9304 17.58 12.5138 17.9849 12 17.9849C11.4861 17.9849 11.0696 17.58 11.0696 17.0804C11.0696 16.5808 11.4861 16.1759 12 16.1759C12.5138 16.1759 12.9304 16.5808 12.9304 17.0804Z",
    fill: "#9C7312"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningToastYellow);
export default __webpack_public_path__ + "static/media/Icon_WarningToast_Yellow.761fc46077f58cc38b884cfec946dbd4.svg";
export { ForwardRef as ReactComponent };